import React from 'react'
import { Card, CardHeader, CardTitle, CardDescription } from '@/components/ui/card'
import { Badge } from '@/components/ui/badge'

export function ProfileHeader({ username, fullName, bio, isVerified, isPrivate }: {
  username: string
  fullName: string
  bio: string
  isVerified: boolean
  isPrivate: boolean
}) {
  return (
    <Card>
      <CardHeader>
        <a 
          href={`https://instagram.com/${username}`}
          target="_blank"
          rel="noopener noreferrer"
          className="block hover:bg-muted/50 rounded-lg -m-6 p-6 transition-colors duration-200"
        >
          <div className="flex items-start justify-between">
            <div className="space-y-1">
              <CardTitle className="text-2xl flex items-center gap-2">
                @{username}
                {isVerified && (
                  <Badge variant="secondary" className="text-xs">Verified</Badge>
                )}
              </CardTitle>
              <CardDescription className="text-base">
                {fullName}
              </CardDescription>
              {bio && (
                <p className="text-sm text-muted-foreground mt-2 max-w-2xl">
                  {bio}
                </p>
              )}
            </div>
            <Badge variant={isPrivate ? 'destructive' : 'default'}>
              {isPrivate ? 'Private' : 'Public'}
            </Badge>
          </div>
        </a>
      </CardHeader>
    </Card>
  )
}

export default ProfileHeader


